import { gsap, ScrollTrigger, smoothScrollObj } from "../layout";

// bootstrap collapse
import Collapse from 'bootstrap/js/dist/collapse';